import { useEffect, useState } from 'react'

const useAnimatedMount = (open, animationDuration = 300) => {
  const [shouldRender, setShouldRender] = useState(false)
  const [animateIn, setAnimateIn] = useState(false)

  useEffect(() => {
    if (open) {
      setShouldRender(true)
      requestAnimationFrame(() => {
        setAnimateIn(true)
      })
    } else {
      setAnimateIn(false)
      const timeout = setTimeout(() => {
        setShouldRender(false)
      }, animationDuration)
      return () => clearTimeout(timeout)
    }
  }, [open, animationDuration])

  return { shouldRender, animateIn }
}

export { useAnimatedMount }
